import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { Eye, EyeOff } from "lucide-react";
import { GoogleLogin } from '@react-oauth/google'; // ⬅️ ADD THIS IMPORT

function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    // Existing useEffect for fetching data
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/vehicles`)
      .then((res) => res.json())
      .then((data) => console.log(data))
      .catch((err) => console.error("Error fetching vehicles:", err));
  }, []);

  // --- STANDARD LOGIN HANDLER ---
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/admin/login`, {
        email,
        password,
      });

      if (response.data.token) {
        localStorage.setItem("user", JSON.stringify({
          role: response.data.role,
          email: response.data.email,
          id: response.data.userId
        }));

        localStorage.setItem("token", response.data.token);
        localStorage.setItem("userId", response.data.userId);
        navigate("/Dashboard");
      } else {
        setError(response.data.message || "Login failed. Please try again.");
      }
    } catch (err) {
      // If the backend returns "This account was registered with Google..." 
      // this message will be shown here.
      setError(err.response?.data?.message || "Server error. Please try again later.");
    }
  };

  // --- GOOGLE LOGIN HANDLER (NEW) ---
  const handleGoogleSuccess = async (credentialResponse) => {
    setError(""); // Clear any previous error
    try {
      // Send the ID token to the backend for verification and login/registration
      const res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/admin/google-login`, {
        token: credentialResponse.credential,
      });

      // Backend returns the JWT token and user info upon success
      const { token, userId, role } = res.data;

      if (token) {
        localStorage.setItem("token", token);
        localStorage.setItem("userId", userId);
        localStorage.setItem("user", JSON.stringify({
          role: role,
          email: res.data.email,
          id: userId
        }));
        
        navigate("/Dashboard");
      } else {
         setError("Google login failed: Token missing from server response.");
      }
    } catch (err) {
      console.error("Google login error:", err.response?.data || err);
      setError(err.response?.data?.message || "Google login failed. Please try again.");
    }
  };


  return (
    <div className="flex flex-col md:flex-row items-center justify-center min-h-screen bg-gray-100 p-6"
      style={{
        backgroundImage: "url('/assets/img/bg-3.jpg')",
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
      }}
    >
      {/* Logo Section (No change) */}
      <div className="flex flex-col items-center mb-10 md:mb-0 md:mr-10">
        <img
          src="/assets/img/oneHub_logo1.png"
          alt="Logo"
          className="w-32 h-32 mb-4 rounded-full shadow-lg"></img>
        <h1 className="text-4xl font-bold text-center bg-white px-4 py-2 rounded shadow">
          <span className="bg-black text-white px-2 rounded">One</span> CRM
        </h1>
        <h2 className="text-2xl font-bold mb-6 text-center text-black">Admin Login</h2>
      </div>

      {/* Login Form Section (Modified) */}
      <div className="bg-white p-8 rounded shadow-md w-full max-w-md">
        <h2 className="text-2xl font-bold mb-6 text-center text-black">Login</h2>

        {error && <div className="bg-red-100 text-red-600 px-4 py-2 mb-4 rounded">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block font-semibold text-gray-800">Email</label>
            <input
              type="email"
              placeholder="Enter your email"
              className="w-full p-2 border border-gray-300 rounded"
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div className="mb-4">
            <label className="block font-semibold text-gray-800">Password</label>
            <div className="relative">
              <input
                type={showPassword ? "text" : "password"}
                placeholder="Enter your password"
                className="w-full p-2 border border-gray-300 rounded pr-10"
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <button
                type="button"
                className="absolute top-1/2 right-3 transform -translate-y-1/2 text-gray-500 hover:text-black"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
              </button>
            </div>
          </div>

          <button
            type="submit"
            className="w-full bg-black text-white py-2 rounded hover:bg-gray-800 transition"
          >
            Login
          </button>
        </form>

        {/* ⬇️ ADD GOOGLE LOGIN SECTION HERE */}
        <div className="flex items-center my-4">
          <div className="flex-grow border-t border-gray-300"></div>
          <span className="flex-shrink mx-4 text-gray-500 text-sm">OR</span>
          <div className="flex-grow border-t border-gray-300"></div>
        </div>

        <div className="flex justify-center">
            <GoogleLogin
                onSuccess={handleGoogleSuccess}
                onError={() => setError("Google sign-in failed.")}
                // size="large" // Optional: customize button appearance
                // theme="outline"
                // text="signin_with"
            />
        </div>
        
        <p className="text-sm mt-4 text-center">
          <Link to="/forgot-password" className="text-black underline hover:text-gray-700">
            Forgot Password?
          </Link>
        </p>

        {/* Existing Link to Register */}
        {/* ... */}
      </div>
    </div>
  );
}

export default AdminLogin;